import { GetRegion } from 'constants.js';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { jsonParseTraslation, jsonParseCatch } from 'utils/getTranslation';

export default function getCountryList(type) {
  const translationsState = useSelector(state => state.metadata.translations);
  const translations = jsonParseTraslation(translationsState);
  const assets = useSelector(state => state.asset);
  const accessString = useSelector(
    state => state.metadata.access_select_country,
  );
  const replacedString = accessString?.replace(/ "/g, '"');
  const accessSelectCountry = replacedString && jsonParseCatch(replacedString);

  const isEnable = get(accessSelectCountry, type, false);

  if (isEnable) {
    return accessSelectCountry?.country_list?.map(country => ({
      region: country.region,
      name: translations?.[country?.text],
      code: country?.region,
      flag: assets?.[country?.icon_active],
    }));
  }
  return false;
}

export const FLAG_BY_FLOW = {
  LOGIN: 'login_enable',
  REGISTER: 'register_enable',
  PAYMENT: 'payment_enable',
};
